import type { CreateSiteData, Site } from '@/types/site';
import type { SiteAddTabProps, SiteEditTabProps } from './types';

type WaterInfoTabProps = SiteEditTabProps | SiteAddTabProps;

export default function WaterInfoTab({
  site,
  onSiteChange: handleSiteChange,
}: WaterInfoTabProps) {
  // 타입 안전한 사이트 변경 핸들러

  const handleSiteChangeTyped = (updatedSite: Site | CreateSiteData) => {
    // 타입 단언: SiteEditTabProps와 SiteAddTabProps의 유니온 타입 처리
    (handleSiteChange as (site: Site | CreateSiteData) => void)(updatedSite);
  };
  return (
    <div className="space-y-6">
      <div className="bg-blue-50 p-4 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          급수 계획 정보
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              계획 인구수
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.plan?.people || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    plan: {
                      ...site.waterSupplyInfo?.plan,
                      people: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              계획 가구수
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.plan?.family || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    plan: {
                      ...site.waterSupplyInfo?.plan,
                      family: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              계획 1인당 급수량
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.plan?.waterSupplyPerPerson || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    plan: {
                      ...site.waterSupplyInfo?.plan,
                      waterSupplyPerPerson: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-4 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          현재 급수 정보
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              현재 인구수
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.current?.people || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    current: {
                      ...site.waterSupplyInfo?.current,
                      people: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              현재 가구수
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.current?.family || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    current: {
                      ...site.waterSupplyInfo?.current,
                      family: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              현재 1인당 급수량
            </label>
            <input
              type="number"
              value={site.waterSupplyInfo?.current?.waterSupplyPerPerson || ''}
              onChange={(e) =>
                handleSiteChangeTyped({
                  ...site,
                  waterSupplyInfo: {
                    ...site.waterSupplyInfo,
                    current: {
                      ...site.waterSupplyInfo?.current,
                      waterSupplyPerPerson: Number(e.target.value) || 0,
                    },
                  },
                })
              }
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          급수 제한사항
        </label>
        <textarea
          value={site.waterSupplyInfo?.supplyLimit || ''}
          onChange={(e) =>
            handleSiteChangeTyped({
              ...site,
              waterSupplyInfo: {
                ...site.waterSupplyInfo,
                supplyLimit: e.target.value,
              },
            })
          }
          rows={3}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>
  );
}
